import { Dispatch } from '@reduxjs/toolkit'

import { getPayrollPeriods as getPayrollPeriodsApiCall } from '@/helpers/api-ts/payrollPeriod'
import { clearSentrySessionUser } from '@/helpers/sentry'
import { PayrollPeriod } from '@/models'
import {
    APP_GET_PAYROLL_PERIODS_FAILURE, APP_GET_PAYROLL_PERIODS_REQUEST, APP_GET_PAYROLL_PERIODS_SUCCESS,    APP_LOGOUT,
    AUTH_UNSET_TOKENS,
    SET_APP_ERROR,
} from '@/redux/actionTypes'

import { AppAction, AppError } from './appLegacyReducer'

export const setAppError = (error: AppError | null): AppAction => ({ type: SET_APP_ERROR, error })

export const logout = () => (dispatch: Dispatch): void => {
    clearSentrySessionUser()
    dispatch({ type: APP_LOGOUT })
    dispatch({ type: AUTH_UNSET_TOKENS })
}

export const getPayrollPeriods = () => async (dispatch: Dispatch): Promise<void> => {
    dispatch({ type: APP_GET_PAYROLL_PERIODS_REQUEST })

    try {
        const payrollPeriods = await getPayrollPeriodsApiCall()

        const sortedPayrollPeriods = payrollPeriods.sort(
            (payrollPeriodA: PayrollPeriod, payrollPeriodB: PayrollPeriod) => payrollPeriodA.year - payrollPeriodB.year
                || payrollPeriodA.periodNumber - payrollPeriodB.periodNumber,
        )

        dispatch({
            type: APP_GET_PAYROLL_PERIODS_SUCCESS,
            payrollPeriods: sortedPayrollPeriods,
        })
    } catch {
        dispatch({ type: APP_GET_PAYROLL_PERIODS_FAILURE })
    }
}
